import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'primereact/button';
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useOutletContext } from 'react-router-dom';
import { queryCompaniesRoleList, updateCompaniesRoleFunc } from '../../utility/service/company-service';
import { checkDpSuccess } from '../../utility/service/tool-service';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MessageContext,handleSuccessMessage } from '../../store/messageStore';
import { InputSwitch } from 'primereact/inputswitch';
import { useEditableFlag } from '../../hooks/useEditableFlag';

const CompanyList_RoleMapping = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [roleList,setRoleList] = useState([]);
    const [funcList,setFuncList] = useState([]);
    const [selRole,setSelRole] = useState(null);
    const [selFunc,setSelFunc] = useState([]);
    const [editAction,setEditAction] = useState("detail");
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const isEditable = useEditableFlag('B10201'); // control edit by B10201


    const btnBackTo = ()=>{
        navigate("/management/companyList")
    }

    const axios_queryCompaniesRoleList = ()=>{
        queryCompaniesRoleList({companySeq:itemObj?.companySeq})
        .then((res)=>{
            if(checkDpSuccess(res)){
                let data = res?.data?.RespBody?.roleDtoList;
                setRoleList(data);
                if(data?.length > 0){ //如果有角色 預設選擇第一筆顯示
                    handleRoleChange(data[0]);
                }
                
            }
        })
    }

    useEffect(()=>{
        if(action!==''){
            axios_queryCompaniesRoleList();
        }else{
            btnBackTo();
        }
    },[action]);



    const handleRoleChange = (selectVal)=>{        
        const newValue = selectVal;
        if (newValue === null) { //連續點同一個位置值會被清空 需重新設定值
            setSelRole((pre)=>{
                setFuncList(pre?.roleFuncList);
                let isCheck = pre?.roleFuncList?.filter((item)=>item.isCheck==='Y')
                setSelFunc(isCheck);
                setEditAction("detail");
                return pre
            });
            return;
        }
        setSelRole(selectVal);
        setFuncList(selectVal?.roleFuncList);
        let isCheck = selectVal?.roleFuncList?.filter((item)=>item.isCheck==='Y')
        setSelFunc(isCheck);
        setEditAction("detail");
    }

    const recoverSelect = ()=>{ //復原原本勾選項目 如果放棄編輯的話
        setFuncList(selRole?.roleFuncList);
        let isCheck = selRole?.roleFuncList?.filter((item)=>item.isCheck==='Y')
        setSelFunc(isCheck);
    }

    const onFuncSelChange = (e)=>{
          if (editAction==='detail' || !isEditable) {
            return; 
        }
        const selected = e.value || [];
        setSelFunc(selected);
        // 勾選同步調整 editableFlag：選取=Y，未選=N
        setFuncList(prev => prev.map(func => {
            const isSelected = selected.some(item => item.funcId === func.funcId);
            return { ...func, editableFlag: isSelected ? 'Y' : 'N' };
        }));
    }

    const confirmRoleFunc = ()=>{
        let roleSeq = selRole?.roleSeq
        let roleFuncList = selFunc?.map((item)=>{
            const matched = funcList?.find(f=> f.funcId === item.funcId);
            return {
                funcId: item.funcId,
                editableFlag: ((matched?.editableFlag) || (item?.editableFlag) || 'N')
            }
        });
        let reqBody = {
            roleSeq,
            roleFuncList
        }
        updateCompaniesRoleFunc(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
                    axios_queryCompaniesRoleList();
                    setEditAction("detail");
                }
            })
    }


    const funFooter = ()=>{
        return (
            <div className="col-12 gap-2 flex-all-center">
            {
            ( editAction === 'detail') ?( <div className="col-12 gap-2 flex-all-center">
                <Button disabled={!isEditable} label={t("button.edit")} onClick={(e) => {
                    e.preventDefault();
                    setEditAction('update');
                }} type="button" size="small" />
            </div>):(<>
                <Button type="button" label={t("button.confirm")} size="small" onClick={()=>{confirmRoleFunc();}} />
                <Button outlined size="small" type="button" label={t("button.cancel")} onClick={(e) => {
                    setEditAction('detail');
                    recoverSelect();
                    
                }} />
            </>)
            }
            </div>
        )
    }


  return (
    <>
    {/* 返回上頁 */}
    <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
            <Button rounded text onClick={() => { btnBackTo(); }}>
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t('button.return_to_list')}
            </Button>
        </div>
    </div>
      <div className="p-card bg-gray">
        <div className="p-card-body">
           {t('org_name')}: {itemObj?.name}
        </div>
    </div>
    <div className="p-card">

        <div className="p-card-body">
            <div className="grid">
                <div className="col-12 lg:col-4">
                <DataTable emptyMessage={t('no_rec')} value={roleList} selection={selRole} onSelectionChange={(e) => {handleRoleChange(e?.value)}} dataKey="roleSeq" tableStyle={{ minWidth: 'auto' }}>
                    <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                    <Column field="symbol" header={t('role_symbol')}></Column>
                    <Column field="name" header={t('role_name')}></Column>
                </DataTable>

                </div>
                <div className="col-12 lg:col-8">
                <div className="col-12 gap-2 flex-all-center">
            </div>
                <DataTable emptyMessage={t('no_rec')} footer={funFooter} value={funcList} scrollable scrollHeight="50vh" selectionMode="multiple" selection={selFunc} onSelectionChange={(e) => onFuncSelChange(e)} dataKey="funcId" tableStyle={{ minWidth: 'auto' }} className={!isEditable ? 'disabled-table' : ''}>
                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    <Column field="funcId" header={t('fun_id')}></Column>
                    <Column field="name" header={t('fun_name')}></Column>
                    <Column field="editableFlag" header={t('editFlag')}
                        body={(rowData)=> (
                            <InputSwitch checked={(rowData?.editableFlag||'N')==='Y'} disabled={!isEditable || editAction==='detail'} onChange={(e)=>{
                                setFuncList(prev=> prev.map(f=> f.funcId===rowData.funcId ? {...f, editableFlag: e.value? 'Y':'N'} : f));
                                if(selFunc && selFunc.some(x=>x.funcId===rowData.funcId)){
                                    setSelFunc(prev=> prev.map(f=> f.funcId===rowData.funcId ? {...f, editableFlag: e.value? 'Y':'N'} : f));
                                }
                            }} />
                        )}
                    ></Column>
                
                </DataTable>

                </div>
            </div>
       
        </div>
    </div>

    </>
  
  )
}

export default CompanyList_RoleMapping